import { render, staticRenderFns } from "./complaintManageAdd.vue?vue&type=template&id=5bcdca6c&scoped=true"
import script from "./complaintManageAdd.vue?vue&type=script&lang=js"
export * from "./complaintManageAdd.vue?vue&type=script&lang=js"
import style0 from "./complaintManageAdd.vue?vue&type=style&index=0&id=5bcdca6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcdca6c",
  null
  
)

export default component.exports